import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Using `}<inlineCode parentName="p">{`set`}</inlineCode>{` replaces any property value that may have been set on a person profile. In contrast, `}<inlineCode parentName="p">{`set_once`}</inlineCode>{` only sets the property if it has never been set before.`}</p>
    <p><inlineCode parentName="p">{`set`}</inlineCode>{` is typically used for properties that may change over time – e.g., email, current plan, organization name. `}<inlineCode parentName="p">{`set_once`}</inlineCode>{` is typically only used for information that is guaranteed to never change – e.g., the first URL a user visited, or the date a user first logged in.`}</p>
    <p>{`For example:`}</p>
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.capture(
    'event_name', 
    { 
        $set: { name: 'Max Hedgehog'  },
        $set_once: { initial_url: '/blog' },
    }
)
posthog.capture(
    'event_name', 
    { 
        $set: { name: 'Mr. Fox'  },
        $set_once: { initial_url: '/pricing' },
    }
)
// name: 'Mr. Fox'
// initial_url: '/blog'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`client.capture({
    distinctId: 'distinct_id',
    event: 'event_name',
    properties: {
        $set: { name: 'Max Hedgehog'  },
        $set_once: { initial_url: '/blog' },
    },
})
client.capture({
    distinctId: 'distinct_id',
    event: 'event_name',
    properties: {
        $set: { name: 'Mr. Fox'  },
        $set_once: { initial_url: '/pricing' },
    },
})
// name: 'Mr. Fox'
// initial_url: '/blog'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    'distinct_id',
    event='event_name',
    properties={
        '$set': {'name': 'Max Hedgehog'},
        '$set_once': {'initial_url': '/blog'}
    }
)
posthog.capture(
    'distinct_id',
    event='event_name',
    properties={
        '$set': {'name': 'Mr. Fox'},
        '$set_once': {'initial_url': '/pricing'}
    }
)
# name: 'Mr. Fox'
# initial_url: '/blog'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
    'distinctId' => 'distinct_id',
    'event' => 'event_name',
    'properties' => array(
        '$set' => array(
            'name' => 'Max Hedgehog'
        ),
        '$set_once' => array(
            'initial_url' => '/blog'
        )
    )
));
PostHog::capture(array(
    'distinctId' => 'distinct_id',
    'event' => 'event_name',
    'properties' => array(
        '$set' => array(
            'name' => 'Mr. Fox'
        ),
        '$set_once' => array(
            'initial_url' => '/pricing'
        )
    )
));
# name: 'Mr. Fox'
# initial_url: '/blog'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`posthog.capture({
    distinct_id: 'distinct_id',
    event: 'event_name',
    properties: {
        '$set': { name: 'Max Hedgehog' },
        '$set_once': { initial_url: '/blog' }
    }
})
posthog.capture({
    distinct_id: 'distinct_id',
    event: 'event_name',
    properties: {
        '$set': { name: 'Mr. Fox' },
        '$set_once': { initial_url: '/pricing' }
    }
})
# name: 'Mr. Fox'
# initial_url: '/blog'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
    DistinctId: "distinct_id",
    Event:      "event_name",
    Properties: map[string]interface{}{
        "$set": map[string]interface{}{
            "name": "Max Hedgehog",
        },
        "$set_once": map[string]interface{}{
            "initial_url": "/blog",
        },
    },
})
client.Enqueue(posthog.Capture{
    DistinctId: "distinct_id",
    Event:      "event_name",
    Properties: map[string]interface{}{
        "$set": map[string]interface{}{
            "name": "Mr. Fox",
        },
        "$set_once": map[string]interface{}{
            "initial_url": "/pricing",
        },
    },
})
// name: 'Mr. Fox'
// initial_url: '/blog'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`posthog.capture("distinct_id", "event_name", new HashMap<String, Object>() {
  {
    put("$set",  new HashMap<String, Object>() {       
      {
        put("name", "Max Hedgehog");
      }
    });
    put("$set_once",  new HashMap<String, Object>() {
      {
        put("initial_url", "/blog");
      }
    });
  }
});
posthog.capture("distinct_id", "event_name", new HashMap<String, Object>() {
  {
    put("$set",  new HashMap<String, Object>() {       
      {
        put("name", "Mr. Fox");
      }
    });
    put("$set_once",  new HashMap<String, Object>() {
      {
        put("initial_url", "/pricing");
      }
    });
  }
});
// name: 'Mr. Fox'
// initial_url: '/blog'
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      